
import { Component, Vue } from 'vue-property-decorator'
import i18n from '@/i18n'
import TeaserAccountTile from '@/components/tile/TeaserAccountTile.vue'
import { getQueryParameterKey } from '@/utils/utils'

@Component({ i18n, components: { TeaserAccountTile } })
export default class ThankYouPage extends Vue {
  private vorgang = ''
  private url = window.ENV_CONFIG.REDIRECTS.PERSONAL_DATA_PAGE || ''

  private mounted() {
    this.vorgang = getQueryParameterKey()
  }
}
